import { dispatcher, api } from 'react-structure-admin';

export const TERMOFUSE = 'TERMOFUSE';
export const TERMOFUSE_GET_LAST_PUBLISHED = 'TERMOFUSE_GET_LAST_PUBLISHED';
export const TERMOFUSE_GET_LAST_PUBLISHED_FINISHED =
  'TERMOFUSE_GET_LAST_PUBLISHED_FINISHED';

export const TERMOFUSE_GET_LAST_ACCEPTANCE = 'TERMOFUSE_GET_LAST_ACCEPTANCE';
export const TERMOFUSE_GET_LAST_ACCEPTANCE_FINISHED =
  'TERMOFUSE_GET_LAST_ACCEPTANCE_FINISHED';

export const getLastTermOfUsePublished = (onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'term-of-use',
    actionType: TERMOFUSE_GET_LAST_PUBLISHED,
    effect: async () => api.get('term-of-use', 'last-published'),
    onSuccess
  });
};

export const getLastTermOfUseAcceptance = (tenantId, onSuccess) => async (
  dispatch
) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'term-of-use',
    actionType: TERMOFUSE_GET_LAST_ACCEPTANCE,
    effect: async () => api.get('term-of-use', `acceptance/last/${tenantId}`),
    onSuccess
  });
};
